import { render } from "./CabCardMobile.vue?vue&type=template&id=5623d5ea&scoped=true"
import script from "./CabCardMobile.vue?vue&type=script&lang=js"
export * from "./CabCardMobile.vue?vue&type=script&lang=js"

import "./CabCardMobile.vue?vue&type=style&index=0&id=5623d5ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5623d5ea"]])

export default __exports__